import { ChangeEvent, useState } from "react";

import { Toggle } from "@vimeo/iris/components";
import { Text } from "@vimeo/iris/typography";

import { Spinner } from "@salesforce/design-system-react";

import { Video } from "vimeo";
import { updateEmbedSettings } from "./embedSettings";

import "./common.scoped.scss";

interface Props {
    video: Video;
    onUpdate: (video: Video) => void;
    onError: (msg: string) => void;
}

export function Actions(props: Props) {
    const { video, onUpdate, onError } = props;
    const [loading, setLoading] = useState(false);

    async function onSettingsChange(e: ChangeEvent, propertyName: string) {
        setLoading(true);

        const buttons: any = {};
        buttons[propertyName] = (e.target as HTMLInputElement).checked;
        try {
            const updatedVideo = await updateEmbedSettings(video, {
                buttons,
            });

            onUpdate(updatedVideo);
        } catch (err) {
            onError("Failed to save changes. Please try again later.");
        }

        setLoading(false);
    }

    return (
        <>
            {loading && <Spinner />}
            <Text size={300} style={{ fontWeight: 500 }}>
                Actions
            </Text>
            <div className="toggles-container">
                <div className="slds-form-element">
                    <div className="slds-form-element__control">
                        <Toggle
                            label="Like"
                            checked={video.embed.buttons.like}
                            onChange={(e) => onSettingsChange(e, "like")}
                        />
                    </div>
                </div>
                <div className="slds-form-element">
                    <div className="slds-form-element__control">
                        <Toggle
                            label="Watch Later"
                            checked={video.embed.buttons.watchlater}
                            onChange={(e) => onSettingsChange(e, "watchlater")}
                        />
                    </div>
                </div>
                <div className="slds-form-element">
                    <div className="slds-form-element__control">
                        <Toggle
                            label="Share"
                            checked={video.embed.buttons.share}
                            onChange={(e) => onSettingsChange(e, "share")}
                        />
                    </div>
                </div>
                <div className="slds-form-element">
                    <div className="slds-form-element__control">
                        <Toggle
                            label="Embed"
                            checked={video.embed.buttons.embed}
                            onChange={(e) => onSettingsChange(e, "embed")}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}
